module.exports = __webpack_public_path__ + "static/media/flipTheCards_2.a3d2d922.mp3";